export default "__VITE_ASSET__BdPlTCv6__"